export default "__VITE_ASSET__1480141d__"